import React from 'react';
const appEnv = process.env.APP_ENV;
import PropTypes from 'prop-types';

const DisplayFormikState = ({ props, displayFormikState }) => {
    return (
        <>
            {appEnv !== 'production' && displayFormikState && (
                <div style={{ margin: '1rem 0' }}>
                    <h3 style={{ fontFamily: 'monospace' }} />
                    <pre
                        style={{
                            background: '#f6f8fa',
                            fontSize: '.65rem',
                            padding: '.5rem',
                        }}
                    >
                        <strong>props</strong> = {JSON.stringify(props, null, 2)}
                    </pre>
                </div>
            )}
        </>
    );
}; //https://codesandbox.io/s/formik-example-with-radio-group-9tfv5?from-embed=&file=/index.js:1395-1399

DisplayFormikState.defaultProps = {
    displayFormikState: true,
};
DisplayFormikState.propTypes = {
    props: PropTypes.object.isRequired,
    displayFormikState: PropTypes.bool,
};

export default DisplayFormikState;
